<template>
  <div class="download-content">
    <h3 class="account-sub-title d-none d-md-block">
      <i class="sicon-envelope align-middle mr-3"></i>{{ translations.messages }}
    </h3>
    <div id="accordion3" class="messages-accordion">
      <div class="card card-accordion accordion-boxed" v-for="item in messages" :key="item.id">
        <a
          class="card-header collapsed"
          :class="[item.messageHasBeenRead ? 'old-message' : 'new-message']"
          href="#"
          data-toggle="collapse"
          :data-target="`#collapse-${item.id}`"
          aria-expanded="false"
          :aria-controls="`#collapse-${item.id}`"
          @click="markAsRead(item)"
        >
          <i
            class="fas"
            :class="[item.systemMessageType === 1 ? 'fa-info-circle' : 'fa-exclamation-triangle']"
          />
          <span class="message-title-sender">{{ item.sender }}</span>
          <span class="message-spacer px-3"> - </span>
          <span class="message-intro-text">
            {{ item.subject }}
          </span>
          <span class="message-time">
            {{ formatDate(item.createdDate, 'HH:mm') }} h <br />
            {{ formatDate(item.createdDate, 'dd.MM.yyyy') }}
          </span>
        </a>
        <div :id="`collapse-${item.id}`" class="collapse" data-parent="#accordion3">
          <p :style="item.htmlContent ? 'padding-bottom: 0px;' : ''">
            {{ item.content }}
          </p>
          <p v-if="item.htmlContent" v-html="item.htmlContent" style="padding-top: 0px;"></p>
        </div>
      </div>
      <pagination :action="actionName" />
    </div>
    <p v-if="messages && messages.length === 0">No Messages.</p>
    <router-link exact :to="{ name: 'Home' }" class="btn btn-primary text-transform-none mb-2">
      {{ translations.continueShopping }}
    </router-link>
    <button class="btn btn-primary ml-2 mb-2" @click="markAllMessagesAsRead">
      {{ translations.markAllAsRead }}
    </button>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { pager } from '@/mixins';

import api from '@/services/api';
import Pagination from '@/components/shared/Pagination.vue';

export default {
  name: 'Messages',
  mixins: [pager],
  components: {
    Pagination,
  },
  data() {
    return {
      actionName: 'getMessages',
    };
  },
  computed: {
    messages() {
      return this.$store.getters.getMessages;
    },
  },
  methods: {
    formatDate(date, dateFormat) {
      return format(new Date(date), dateFormat);
    },
    markAsRead(item) {
      if (item.messageHasBeenRead) return;
      api.markMessageAsRead(item.id).then(() => {
        this.$store.dispatch('getMessages', this.searchConfig);
        this.$store.dispatch('getUnreadMessagesCount');
      });
    },
    markAllMessagesAsRead() {
      api.markAllMessagesAsRead().then(() => {
        this.$store.dispatch('getMessages', this.searchConfig);
        this.$store.dispatch('getUnreadMessagesCount');
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getMessages', this.searchConfig);
  },
};
</script>
